/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { areEqual } from 'fierry/type/compare';

import fork from 'fierry/data/fork';


export default class Logic
{
  static of (object, ...args)
  {
    while (object instanceof Logic)
    {
      object = object.object;
    }

    return new this(object, ...args);
  }


  constructor (...objects)
  {
    this.objects = objects;

    this.object = objects[0];
  }


  get cass ()
  {
    return this.object.cass;
  }


  getEntity ()
  {
    let object = this.object;

    while (object instanceof Logic)
    {
      object = object.object;
    }

    return object;
  }


  mutate (callback, ...args)
  {
    if (this.object === this.objects[0])
    {
      this.object = fork(this.object);
    }

    callback(this.object, ...args);
  }


  equals (other)
  {
    return other?.constructor === this.constructor && this.objects.length === other.objects.length && this.objects.every((object, index) => areEqual(object, other.objects[index]));
  }


};
